import React, { useState, useEffect } from 'react';
import axios from '../../api/axios';
import { useNavigate } from 'react-router-dom';
import { FiArrowLeft, FiTrendingUp, FiUsers, FiDollarSign, FiTarget, FiActivity } from 'react-icons/fi';

const Analytics = () => {
  const [analytics, setAnalytics] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchAnalytics();
  }, []);

  const fetchAnalytics = async () => {
    try {
      const { data } = await axios.get('/api/crm/analytics');
      setAnalytics(data);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="p-6">Loading...</div>;

  const conversionRate = analytics?.conversionRate || 0;
  const totalLeads = analytics?.leadStats?.reduce((sum, stat) => sum + parseInt(stat.count), 0) || 0;
  const _convertedLeads = analytics?.leadStats?.find(stat => stat.status === 'Converted')?.count || 0;

  return (
    <div className="p-6">
      <div className="flex items-center gap-4 mb-6">
        <button
          onClick={() => navigate('/crm')}
          className="flex items-center gap-2 text-gray-600 hover:text-gray-800 transition-colors"
        >
          <FiArrowLeft size={20} />
          Back to CRM Dashboard
        </button>
        <h1 className="text-2xl font-bold">CRM Analytics</h1>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center justify-between mb-4">
            <div className="p-3 bg-blue-100 rounded-lg">
              <FiUsers className="text-blue-600" size={24} />
            </div>
          </div>
          <div className="text-sm text-gray-600 mb-1">Total Leads</div>
          <div className="text-3xl font-bold text-gray-900">{totalLeads}</div>
        </div>

        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center justify-between mb-4">
            <div className="p-3 bg-green-100 rounded-lg">
              <FiTarget className="text-green-600" size={24} />
            </div>
          </div>
          <div className="text-sm text-gray-600 mb-1">Conversion Rate</div>
          <div className="text-3xl font-bold text-gray-900">{conversionRate}%</div>
        </div>

        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center justify-between mb-4">
            <div className="p-3 bg-purple-100 rounded-lg">
              <FiDollarSign className="text-purple-600" size={24} />
            </div>
          </div>
          <div className="text-sm text-gray-600 mb-1">Pipeline Value</div>
          <div className="text-3xl font-bold text-gray-900">$0</div>
        </div>

        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center justify-between mb-4">
            <div className="p-3 bg-orange-100 rounded-lg">
              <FiActivity className="text-orange-600" size={24} />
            </div>
          </div>
          <div className="text-sm text-gray-600 mb-1">Active Deals</div>
          <div className="text-3xl font-bold text-gray-900">0</div>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white rounded-lg shadow p-6">
          <h2 className="text-lg font-semibold mb-4 flex items-center gap-2">
            <FiTrendingUp className="text-blue-600" />
            Lead Status Distribution
          </h2>
          <div className="space-y-3">
            {analytics?.leadStats?.map((item) => (
              <div key={item.status} className="flex justify-between items-center">
                <span className="text-gray-700">{item.status}</span>
                <div className="flex items-center gap-2">
                  <div className="w-24 bg-gray-200 rounded-full h-2">
                    <div 
                      className="bg-blue-600 h-2 rounded-full" 
                      style={{ width: `${(item.count / totalLeads * 100) || 0}%` }}
                    ></div>
                  </div>
                  <span className="text-sm font-medium w-8">{item.count}</span>
                </div>
              </div>
            )) || []}
          </div>
        </div>

        <div className="bg-white rounded-lg shadow p-6">
          <h2 className="text-lg font-semibold mb-4 flex items-center gap-2">
            <FiDollarSign className="text-green-600" />
            Deal Stages
          </h2>
          <div className="space-y-3">
            <div className="text-center py-4 text-gray-500">
              <p>No deal data available</p>
            </div>
          </div>
        </div>
      </div>

      {!analytics && (
        <div className="text-center py-12 text-gray-500">
          <FiActivity size={48} className="mx-auto mb-3 text-gray-300" />
          <p>No analytics data available yet.</p>
        </div>
      )}
    </div>
  );
};

export default Analytics;
